export default function ({ $axios, $sentry }) {
  $axios.onError((error) => {
    $sentry.captureException(error, { extra: error.config })
  })
}
